import { ResourcesConfig } from 'aws-amplify';

export interface AppConfig {
  cognito: {
    userPoolId: string;
    userPoolClientId: string;
    region: string;
    domain: string;
  };
  api: {
    endpoint: string;
  };
  events?: {
    endpoint: string;
    region: string;
  };
  app: {
    name: string;
    version: string;
  };
}

let cachedConfig: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cachedConfig) {
    return cachedConfig;
  }

  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error('Failed to load config');
    }
    cachedConfig = await response.json();
    return cachedConfig!;
  } catch (error) {
    console.error('Failed to load config:', error);
    // Return default config for development
    return {
      cognito: {
        userPoolId: 'us-east-1_placeholder',
        userPoolClientId: 'placeholder',
        region: 'us-east-1',
        domain: 'snailman-dev-auth',
      },
      api: {
        endpoint: 'http://localhost:3001',
      },
      app: {
        name: 'Snailman',
        version: '0.1.0',
      },
    };
  }
}

export function getAmplifyConfig(config: AppConfig): ResourcesConfig {
  const redirectUrl = typeof window !== 'undefined'
    ? `${window.location.origin}/auth/callback`
    : 'http://localhost:3000/auth/callback';

  const amplifyConfig: ResourcesConfig = {
    Auth: {
      Cognito: {
        userPoolId: config.cognito.userPoolId,
        userPoolClientId: config.cognito.userPoolClientId,
        loginWith: {
          oauth: {
            domain: config.cognito.domain,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [redirectUrl],
            redirectSignOut: [typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000'],
            responseType: 'code',
            providers: ['Google'],
          },
        },
      },
    },
  };

  // Add Events API configuration if available
  if (config.events) {
    amplifyConfig.API = {
      Events: {
        endpoint: config.events.endpoint,
        region: config.events.region,
        defaultAuthMode: 'userPool',
      },
    };
  }

  return amplifyConfig;
}
